import { render, staticRenderFns } from "./comptest.vue?vue&type=template&id=374106f0"
import script from "./comptest.vue?vue&type=script&lang=js"
export * from "./comptest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports